import { EN_REQUEST_ERRORS, IRequesterError, IRequesterResponse } from '@/services/RequestService/IRequester';
import { Either } from 'tsmonad';
import type { AxiosRequestConfig } from 'axios';

export type ResponseEither<P> = Either<IRequesterError, IRequesterResponse<P>>;

export const responseSuccess = <T>(statusCode: number = 200, data: T): ResponseEither<T> => {
  return Either.right({
    statusCode,
    data,
    success: true,
  });
};

export const responseError = <T = any>(
  statusCode: number,
  errorType: EN_REQUEST_ERRORS,
  data?: unknown,
  request?: AxiosRequestConfig,
): ResponseEither<T> => {
  return Either.left({
    statusCode,
    errorType,
    data,
    request,
    success: false,
  });
};
